<div class="card portfolio-card">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5 class="m-0">{{ 'My Portfolio' | translate }}</h5>
      <div class="card-header-right-icon">
        <div class="dropdown">
          <button class="btn dropdown-toggle" type="button" (click)="toggle()">{{ 'BTC' | translate }}</button>
          <div class="dropdown-menu dropdown-menu-end" [class.show]="show"><a class="dropdown-item" href="#">{{ 'ETH' | translate }}</a><a class="dropdown-item" href="#">{{ 'USD' | translate }}</a><a class="dropdown-item" href="#">{{ 'LTC' | translate }}</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-xxl-12 col-xl-7 col-sm-6 box-col-6">
        <div class="portfolio-chart-container">
          <div id="portfolio-chart">
            <apx-chart [series]="portfolio.series" [chart]="portfolio.chart" [plotOptions]="portfolio.plotOptions" [colors]="portfolio.colors" [labels]="portfolio.labels" [fill]="portfolio.fill" [responsive]="portfolio.responsive"></apx-chart>
          </div>
        </div>
      </div>
      <div class="col-xxl-12 col-xl-5 col-sm-6 box-col-6">
        <div class="portfolio-table recent-table table-responsive">
          <table class="table">
            <tbody>
              <tr>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <div class="currency-icon warning">
                      <svg>
                        <use href="assets/svg/icon-sprite.svg#beta"></use>
                      </svg>
                    </div>
                    <div>
                      <h6 class="f-14 mb-1">{{ 'Bitcoin' | translate }}</h6>
                      <div class="d-flex align-items-center gap-1"><span class="status bg-success"></span><span class="f-light">{{ 'BTC' | translate }}</span></div>
                    </div>
                  </div>
                </td>
                <td class="text-end">
                  <h6 class="f-14 f-w-400 mb-1">{{ 'BTC 0.00876543' | translate }}</h6>
                  <span class="font-success">{{ '$14,987.13' | translate }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <div class="currency-icon success">
                      <svg>
                        <use href="assets/svg/icon-sprite.svg#ltc"></use>
                      </svg>
                    </div>
                    <div>
                      <h6 class="f-14 mb-1">{{ 'Ethereum' | translate }}</h6>
                      <div class="d-flex align-items-center gap-1"><span class="status bg-danger"></span><span class="f-light">{{ 'ETH' | translate }}</span></div>
                    </div>
                  </div>
                </td>
                <td class="text-end">
                  <h6 class="f-14 f-w-400 mb-1">{{ 'ETC 1.60876543' | translate }}</h6>
                  <span class="font-danger">{{ '$49,987.13' | translate }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <div class="currency-icon primary">
                      <svg>
                        <use href="assets/svg/icon-sprite.svg#eth"></use>
                      </svg>
                    </div>
                    <div>
                      <h6 class="f-14 mb-1">{{ 'Litecoin' | translate }}</h6>
                      <div class="d-flex align-items-center gap-1"><span class="status bg-success"></span><span class="f-light">{{ 'LTC' | translate }}</span></div>
                    </div>
                  </div>
                </td>
                <td class="text-end">
                  <h6 class="f-14 f-w-400 mb-1">{{ 'LTC 1.60876543' | translate }}</h6>
                  <span class="font-success">{{ '$35,571.25' | translate }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <div class="currency-icon light-blue">
                      <svg>
                        <use href="assets/svg/icon-sprite.svg#dash"></use>
                      </svg>
                    </div>
                    <div>
                      <h6 class="f-14 mb-1">{{ 'Dash' | translate }}</h6>
                      <div class="d-flex align-items-center gap-1"><span class="status bg-success"></span><span class="f-light">{{ 'DSH' | translate }}</span></div>
                    </div>
                  </div>
                </td>
                <td class="text-end">
                  <h6 class="f-14 f-w-400 mb-1">{{ 'DSH 1.80741510' | translate }}</h6>
                  <span class="font-success">{{ '$17,047.30' | translate }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
